import React from 'react';
import { Button, Typography, Box, useMediaQuery, useTheme } from '@mui/material';
import { navigate } from 'gatsby';

interface BasicButtonProps {
  value?: {
    buttonType: 'text' | 'outlined' | 'contained';
    label: string;
    alignSelf?: 'flex-start' | 'center' | 'flex-end';
    alignSelfMobile?: 'flex-start' | 'center' | 'flex-end';
    link: {
      newTab: boolean;
      path: string;
      url: string;
    };
    route: {
      page: {
        slug: {
          current: string;
        };
      };
    };
  };
}

const BasicButton = ({ value }: BasicButtonProps) => {
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!value) return;

  const link = value?.link;
  const route = value?.route?.page?.slug?.current;
  
  // if (!link && !route) return;

  const handleClick = () => {    
    if (route) {
      navigate(`/${route}`);
      return;
    } else if (link.path) {
      navigate(link.path);
      return
    } else if (link.url) {
      // Ensure window is defined (i.e., running in the browser and not during SSR)
      if (typeof window !== 'undefined') {
        if (link.newTab) {
          window.open(link.url, '_blank');
        } else {
          window.location.href = link.url;
        }
      }
    } else {
      return;
    }
  };

  
  const getAlignment = () => {
    if (isMobile) {
      return value?.alignSelfMobile ?? 'flex-start';
    } else {
      return value?.alignSelf ?? 'flex-start';
    }
  }

    return (
      <>
        <Box alignSelf={getAlignment}>
          <Button
            // Action
            onClick={handleClick}
            variant={value.buttonType}
            color="primary"
            size="large"
            sx={{
              py: ['12px', '14px'],
              px: ['50px'],
            }}
          >
            <Typography variant="button">{value?.label}</Typography>
          </Button>
        </Box>
      </>
    );
  
};

export default BasicButton;
